<template>
    <div v-if="substances.length > 0 && linksReady" class="substance-full">
        <button type="button" class="primary smallbutton backbutton" v-if="searchResultsHasMoreThanOneYkNro" v-on:click="returnToSearch">{{ "App.VAKHaku.SubstanceTable.ReturnToSearchResultsButton" | translate}}</button>
        <div class="headerdiv">
            <label class="un-header">{{ "App.VAKHaku.SubstanceTable.UNLabel" | translate}}: {{ ykNro }}</label>
        </div>
        <div class="substance-div" v-for="(aine, index) in substances" :key="index" v-bind:class="{ firstrow: index === 0 }">
            <label class="input-label">{{ aine.nimi }}</label>
            <table class="substance-table">
                <colgroup span="4"></colgroup>
                <thead>
                    <tr>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.ClassTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.ClassCodeTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.PackageGroupTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.FlagsTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.SpecialOrdersTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.RestrictedAmountTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.ExceptionalAmountTHeader')"></th>
                        <th colspan="3" scope="colgroup" v-html="$t('App.VAKHaku.SubstanceTable.PackagesTHeader')"></th>
                        <th colspan="2" scope="colgroup" v-html="$t('App.VAKHaku.SubstanceTable.UNVesselAndBulkContainerTHeader')"></th>
                        <th colspan="2" scope="colgroup" v-html="$t('App.VAKHaku.SubstanceTable.VAKADRVesselTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.VehicleInVesselTransportationTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.TransportationCategoryTHeader')"></th>
                        <th colspan="4" scope="colgroup" v-html="$t('App.VAKHaku.SubstanceTable.TransportationSpecialOrdesTHeader')"></th>
                        <th rowspan="2" scope="rowgroup" v-html="$t('App.VAKHaku.SubstanceTable.DangerNumberTHeader')"></th>
                    </tr>
                    <tr>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.Packaging.PackagingCustomTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.Packaging.SpecialPackageAmountTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.Packaging.CoPackagingAmountTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.UNVessel.AdaptationTermsTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.UNVessel.SpecialOrdersTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.VAKADRVessel.VesselCodesTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.VAKADRVessel.SpecialOrdersTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.TransportationSpecials.PackageTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.TransportationSpecials.BulkTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.TransportationSpecials.LoadDissasemblyAndHandlingTHeader')"></th>
                        <th v-html="$t('App.VAKHaku.SubstanceTable.TransportationSpecials.TransportationEventTHeader')"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="substance-row" v-if="aine.pakkausryhma !== 'KULJETUS KIELLETTY' && !aine.pakkausryhma.includes('alaista')">
                        <td class="substance-column"><code-link-element column="luokka" :code="aine.luokka" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="luokituskoodi" :code="aine.luokituskoodi" :dependantCode="aine.luokka" :index="index" /></td> <!-- HUOM: K�ytet��n sarakkeen 3a koodia, eli luokka-sarakkeen koodia -->
                        <td class="substance-column"><code-link-element column="pakkausryhma" :code="aine.pakkausryhma" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="lipukkeet" :code="aine.lipukkeet" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="erityismaaraykset" :code="aine.erityismaaraykset" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="rajoitetutMaarat" :code="aine.rajoitetutMaarat" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="poikkeusmaarat" :code="aine.poikkeusmaarat" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="pakkaustavat" :code="aine.pakkaustavat" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="erityispakkausmaaraykset" :code="aine.erityispakkausmaaraykset" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="yhteenpakkaamismaaraykset" :code="aine.yhteenpakkaamismaaraykset" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="unIrtotavaraSoveltamisehdot" :code="aine.unIrtotavaraSoveltamisehdot" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="unIrtotavaraErityismaaraykset" :code="aine.unIrtotavaraErityismaaraykset" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="vakADRSailiokoodit" :code="aine.vakADRSailiokoodit" :dependantCode="aine.luokka" :index="index" /></td> <!-- HUOM: K�ytet��n sarakkeen 3a koodia, eli luokka-sarakkeen koodia -->
                        <td class="substance-column"><code-link-element column="vakADRErityismaaraykset" :code="aine.vakADRErityismaaraykset" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="ajoneuvoSailiokuljetuksissa" :code="aine.ajoneuvoSailiokuljetuksissa" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="kuljetuskategoriaTunnelirajoituskoodi" :code="aine.kuljetuskategoriaTunnelirajoituskoodi" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="kuljetusmaarayksetKollit" :code="aine.kuljetusmaarayksetKollit" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="kuljetusmaarayksetIrtotavara" :code="aine.kuljetusmaarayksetIrtotavara" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="kuljetusmaarayksetKuormPurkKasittely" :code="aine.kuljetusmaarayksetKuormPurkKasittely" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="kuljetusmaarayksetKuljetustapahtuma" :code="aine.kuljetusmaarayksetKuljetustapahtuma" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="vaaranTunnusnro" :code="aine.vaaranTunnusnro" :index="index" /></td>
                    </tr>
                    <tr v-else>
                        <td class="substance-column"><code-link-element column="luokka" :code="aine.luokka" :index="index" /></td>
                        <td class="substance-column"><code-link-element column="luokituskoodi" :code="aine.luokituskoodi" :dependantCode="aine.luokka" :index="index" /></td> <!-- HUOM: K�ytet��n sarakkeen 3a koodia, eli luokka-sarakkeen koodia -->
                        <td class="substance-column" colspan="8"><code-link-element column="pakkausryhma" :code="aine.pakkausryhma" :index="index" /></td>
                        <td class="substance-column" colspan="11"><code-link-element column="unIrtotavaraSoveltamisehdot" :code="aine.unIrtotavaraSoveltamisehdot" :index="index" /></td>
                    </tr>
                </tbody>
            </table>
            <iframe-pdf :id="'pdf' + index" :index="index" />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop, Watch } from "vue-property-decorator"
    import AineModel from "../models/aineModel"
    import ApiService from "../services/ApiService"
    import CodeLinkElement from "./CodeLinkElement.vue"
    import IframePdf from "./IframePdf.vue"
    import EmbeddedPdfModel from "../models/embeddedPdfModel"

    @Component({
        components: {
            "code-link-element": CodeLinkElement,
            "iframe-pdf": IframePdf
        }
    })
    export default class VAKSubstanceTable extends Vue {
        mounted(): void {
            this.$nextTick(async () => {
                const results = this.searchResults
                if (results.length > 0) {
                    this.substances = results.filter(a => a.ykNro === this.ykNro)
                    this.getColumnCodeLinks()
                } else {
                    // if we come to page straight from url, not from vakhakupage
                    this.getSearchResultsWithUN()
                }
            })
        }

        beforeUpdate(): void {
            // Close all embedded pdf on mount
            this.$store.dispatch("setEmbeddedPdfFiles", [])
        }

        @Prop(String) readonly ykNro!: string
        substances: Array<AineModel> = []
        apiService: ApiService = new ApiService(this.$store.getters.baseHref)
        linksReady: boolean = true

        get searchResults(): Array<AineModel> {
            return this.$store.getters.vakSearchResults
        }

        get searchResultsHasMoreThanOneYkNro(): boolean {
            if (this.searchResults.length > 0) {
                for (let i = 0; i < this.searchResults.length; i++) {
                    if (i !== this.searchResults.length - 1) {
                        if (this.searchResults[i].ykNro !== this.searchResults[i + 1].ykNro) {
                            return true
                        }
                    }
                }
            }
            return false
        }

        @Watch("searchResults")
        watchSearchResults() {
            this.getColumnCodeLinks()
            this.substances = this.searchResults
        }

        get embeddedPdfFiles(): Array<EmbeddedPdfModel> {
            return this.$store.getters.embeddedPdfFiles
        }

        @Watch("embeddedPdfFiles")
        onEmbeddedPdfFiles(newVal, oldVal) {
            // kun valitaan, avataan iframe
            if (newVal.length >= oldVal.length) {
                // Lis�tty uusi
                if (newVal.length > 1) {
                    for (let i = 0; i < newVal.length; i++) {
                        // Skipataan jo auki olevat iframet, jos pdfUrl ei muutu
                        if (oldVal.find(o => o.pdfUrl === newVal[i].pdfUrl && o.index === newVal[i].index) !== undefined) {
                            continue
                        } else {
                            const iframe: any = document.getElementById("pdf" + newVal[i].index)
                            iframe.src = encodeURI(newVal[i].pdfUrl)
                            iframe.style.display = "block"
                        }
                    }
                } else if (newVal[0] !== undefined) {
                    const iframe: any = document.getElementById("pdf" + newVal[0].index)
                    iframe.src = encodeURI(newVal[0].pdfUrl)
                    iframe.style.display = "block"
                }
            } else {
                // poistettu vanha
                for (let i = 0; i < oldVal.length; i++) {
                    // Skipataan jo auki olevat iframet, jos pdfUrl ei muutu
                    if (newVal.find(n => n.pdfUrl === oldVal[i].pdfUrl && n.index === oldVal[i].index) !== undefined) {
                        continue
                    } else {
                        const iframe: any = document.getElementById("pdf" + oldVal[i].index)
                        iframe.src = ""
                        iframe.style.display = "none"
                    }
                }
            }
        }

        returnToSearch(): void {
            this.$router.push("/VAKHaku")
        }

        getSearchResultsWithUN() {
            this.$store.dispatch("setLoading", true)
            this.apiService.getVAKResultsWithUN(this.ykNro).then((results) => {
                this.substances = results
                this.$store.dispatch("setVakSearchResults", results)
                this.$store.dispatch("setVakApiCallFailed", false)
            }).catch(() => {
                this.$store.dispatch("setVakApiCallFailed", true)
            }).finally(() => {
                this.$store.dispatch("setLoading", false)
            })
        }

        getColumnCodeLinks() {
            this.$store.dispatch("setLoading", true)
            this.linksReady = false
            this.apiService.getColumnCodeLinks(this.ykNro).then(response => {
                this.$store.dispatch("setColumnCodeLinks", response)
            }).finally(() => {
                this.linksReady = true
                this.$store.dispatch("setLoading", false)
            })
        }
    }
</script>

<style scoped>
    .substance-full {
        margin: 0px 30px;
    }

    .backbutton {
        margin-top: 15px;
        margin-bottom: -15px;
    }

    .headerdiv {
        margin-top: 35px;
        margin-bottom: 10px;
    }

        .headerdiv .un-header {
            font-size: 28px;
            font-weight: 600;
        }

    .substance-div {
        width: 100%;
        margin-top: 35px;
    }

        .substance-div.firstrow {
            margin-top: 0;
        }

        .substance-div .input-label {
            width: 100%;
        }

    .substance-table {
        table-layout: fixed;
        width: 100%;
        min-width: 1200px;
    }

        .substance-table thead tr {
            color: white;
            background-color: #026273;
        }

            .substance-table thead tr th {
                font-size: 12px;
                word-break: break-word;
                font-weight: 400;
                text-align: center;
                background-color: #026273;
                color: white;
                border: 1px solid #4a95a2;
                padding-left: 8px;
                padding-right: 8px;
            }

        .substance-table tbody tr td {
            font-size: 12px;
            font-weight: 400;
            text-align: center;
            border-color: #b3b3b3;
        }

        .substance-table .substance-column {
            padding: 7px;
        }
</style>
